<template>
  <!-- <div class="body apply main-bg"> -->
  <div class="body apply">
    <div class="wrap">
      <div
        class="apply-menu-wrap1"
        :style="[pageUrl === '/user/reg/select' ? { display: 'none' } : {}]"
      >
        <div class="top-menu">
          <h1>
            <div
              v-if="
                logo !== '' &&
                logo !== 'null' &&
                logo !== 'undefined' &&
                logo !== null
              "
            >
              <img :src="logo" alt="company logo" style="height: 20px" />
            </div>
            <div v-else alt="company logo" style="height: 20px" />
            <span v-if="mainTitle !== ''" class="whitespace-nowrap">{{
              mainTitle
            }}</span>
            <span v-else>사내어학클래스</span>
          </h1>
          <!-- 모바일용 -->
          <a class="dp-inblock-m m-menu" id="header-menu-btn">
            <img
              @click="openMenu()"
              class="pointer"
              src="../assets/img/m_gnb_sub.png"
              alt="menu"
            />
          </a>
          <ul>
            <!-- <li :class="{'on-blue' : pageType === 'reg'}"> -->
            <li :class="setColor('reg')">
              <a v-if="pageType === 'reg'">신청하기</a>
              <a v-else class="pointer" @click="moveMobileReg()">신청하기</a>
            </li>
            <li :class="setColor('list')" v-if="isRegUser == 'Y'">
              <a class="pointer" @click="moveMobileApplyList()"
                >신청내역 확인</a
              >
            </li>
            <!-- <li :class="{'on-blue' : pageType === 'pw'}">
                        <a class="pointer" @click="moveFixPW()">비밀번호 재설정</a>
                    </li> -->
            <li>
              <a class="pointer" @click="logoutMobile()">Logout</a>
            </li>
          </ul>
        </div>
        <!-- 반응형 메뉴 -->
        <div class="dp-inblock-m m-top-menu" id="default-header-menu">
          <a class="close" id="header-close">
            <img
              @click="closeMenu()"
              class="pointer"
              src="../assets/img/menu_close.png"
              alt=""
            />
          </a>
          <ul class="clear">
            <li><a class="pointer" @click="moveMobileReg()">신청하기</a></li>
            <li v-if="isRegUser == 'Y'">
              <a class="pointer" @click="moveMobileApplyList()"
                >신청내역 확인</a
              >
            </li>
            <!-- <li><a class="pointer" @click="moveFixPW()">비밀번호 재설정</a></li> -->
            <li><a class="pointer" @click="logoutMobile()">Logout</a></li>
          </ul>
        </div>
      </div>
      <router-view></router-view>
    </div>

    <!-- Footer 공통 부분-->

    <div class="footer">
      <div class="div1">
        <div class="content" style="display: block">
          <span class="float-left">
            <div class="float-left">
              <img src="../assets/img/qna_logo.png" />
              <span class="qna-text"> 문의하기 </span>
              <!-- <button class="qna-btn" @click="openModal('qna')">1:1 문의하기</button> -->
              <span class="qna-bar"> | </span>
            </div>
            <div class="float-left qna-text2">
              <span v-for="(item, index) of qaList" :key="index">
                <template v-if="index < 5">
                  담당 매니저: {{ item }}<br />
                </template>
              </span>
            </div>
          </span>
        </div>
      </div>

      <div class="div2" :class="{ 'select-footer': pageUrl === '/user/reg/select' }">
        <div class="content">
          <div class="bottom-wrapper">
            <div class="info-wrapper">
              <p>
                (주)캐럿글로벌 | 서울특별시 용산구 한남동 이태원로 268-20 |
                <span
                  ><a
                    href="https://carrotglobal.com/PrivacyPolicy"
                    target="_blank"
                    rel="noopener noreferrer"
                    >개인정보처리방침</a
                  ></span
                >
                <span> | </span>
                <span
                  ><a
                    href="https://carrotglobal.com/termsOfUse"
                    target="_blank"
                    rel="noopener noreferrer"
                    >이용약관</a
                  ></span
                >
              </p>
              <p>
                대표이사 노상충 Copyright ⓒ<b>CARROT Global</b> Inc. All rights
                reserved.
              </p>
              <p>
                사업자 등록번호 211-88-50791 | 제 2021-서울용산-1952 호 | 연락처
                : 02-518-5467
              </p>
              <p>
                호스팅제공자 : 네이버 클라우드 | 개인정보보호책임자 : 노상충
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <qna-modal v-if="isQnaModalOpened" @close="closeModal()"></qna-modal>
  </div>
</template>

<script>
import QnaModal from "@/components/qnaModal.vue";
export default {
  components: {
    QnaModal,
  },
  data: () => ({
    isQnaModalOpened: false, // 1:1 문의 팝업 on/off
    pageType: "reg",
    pageUrl: "",
    logo: "",
    mainTitle: "",
    qaAdminInfo: "",
    qaList: [],

    pointColor: "blue",
    isRegUser: "N",
  }),

  watch: {
    // 등록 페이지 내의 현재 라우터 경로 감지
    $route(to) {
      this.showProgress(to.fullPath);
    },

    "window.innerWidth"() {
      // console.log('fesfesfesfes')
    },
  },

  mounted() {
    this.pointColor = sessionStorage.getItem("pointColor");
    this.isRegUser = sessionStorage.getItem("isRegUser");
    this.showProgress(this.$route.path);
    // console.log(this.$route.path)
    if (sessionStorage.getItem("logo")) {
      if (
        sessionStorage.getItem("logo") === "undefined" ||
        sessionStorage.getItem("logo") === null ||
        sessionStorage.getItem("logo") === "null"
      ) {
        this.logo = "";
      } else {
        this.logo = sessionStorage.getItem("logo");
      }
    } else {
      this.logo = "";
    }

    if (sessionStorage.getItem("mainTitle")) {
      this.mainTitle = sessionStorage.getItem("mainTitle");
    } else {
      this.mainTitle = "";
    }

    if (sessionStorage.getItem("qaAdminInfo")) {
      this.qaAdminInfo = sessionStorage.getItem("qaAdminInfo");
      // console.log('this.qaAdminInfo', this.qaAdminInfo)
      this.qaList = this.qaAdminInfo.split(",");
    } else {
      this.qaAdminInfo = "";
    }
  },

  methods: {
    moveMobileReg() {
      this.closeMenu();
      this.$router.push("/user/reg/init");
    },

    moveMobileApplyList() {
      this.closeMenu();
      this.$router.push("/user/applyList");
    },

    logoutMobile() {
      /*
            this.closeMenu()
            localStorage.removeItem('userId')
            localStorage.removeItem('accessToken')
            delete this.axios.defaults.headers.common['accessToken']
            var tempCompanyCode = sessionStorage.getItem('companyCode')
            sessionStorage.clear()
            sessionStorage.setItem('companyCode', tempCompanyCode)
            alert('로그아웃 되었습니다.')
            this.$router.push('/user/login') 웹취약점 */
      this.axios
        .get(this.axios.root + this.axios.port + "/login/out")
        .then((res) => {
          if (res.data.err === 0) {
            this.closeMenu();
            localStorage.removeItem("userId");
            localStorage.removeItem("accessToken");
            delete this.axios.defaults.headers.common["accessToken"];
            var tempCompanyCode = sessionStorage.getItem("companyCode");
            sessionStorage.clear();
            sessionStorage.setItem("companyCode", tempCompanyCode);
            alert("로그아웃 되었습니다.");
            this.$router.push("/user/login");
          }
        });
    },

    openMenu() {
      document.getElementById("default-header-menu").style =
        "display:inherit !important;";
    },

    closeMenu() {
      document.getElementById("default-header-menu").style =
        "display:none !important;";
    },

    setColor(type) {
      if (type === this.pageType) {
        if (this.pointColor === "Blue") {
          return "on-blue";
        } else if (this.pointColor === "Red") {
          return "on-red";
        } else if (this.pointColor === "Green") {
          return "on-green";
        }
      } else if (type === this.pageType) {
        if (this.pointColor === "Blue") {
          return "on-blue";
        } else if (this.pointColor === "Red") {
          return "on-red";
        } else if (this.pointColor === "Green") {
          return "on-green";
        }
      }
    },

    //  URL에 따라서 GNB 각 우측 버튼 활성화
    showProgress(path) {
      if (path) {
        this.pageUrl = path;
        if (path.includes("user/reg")) {
          this.pageType = "reg";
        } else if (path.includes("user/applyList")) {
          this.pageType = "list";
        }
      } else {
        this.pageUrl = this.$route.path;
      }
    },

    logout() {
      /*
            localStorage.removeItem('userId')
            localStorage.removeItem('accessToken')
            delete this.axios.defaults.headers.common['accessToken']
            var tempCompanyCode = sessionStorage.getItem('companyCode')
            sessionStorage.clear()
            sessionStorage.setItem('companyCode', tempCompanyCode)
            alert('로그아웃 되었습니다.')
            this.$router.push('/user/login') 웹취약점 */
      this.axios
        .get(this.axios.root + this.axios.port + "/login/out")
        .then((res) => {
          if (res.data.err === 0) {
            localStorage.removeItem("userId");
            localStorage.removeItem("accessToken");

            sessionStorage.removeItem("isRegUser");
            delete this.axios.defaults.headers.common["accessToken"];
            var tempCompanyCode = sessionStorage.getItem("companyCode");
            sessionStorage.clear();
            sessionStorage.setItem("companyCode", tempCompanyCode);
            alert("로그아웃 되었습니다.");
            this.$router.push("/user/login");
          }
        });
    },

    // 모달 열기
    openModal(type) {
      if (type === "qna") {
        this.isQnaModalOpened = true;
      }
    },

    // 모달 닫기
    closeModal() {
      if (this.isQnaModalOpened) {
        this.isQnaModalOpened = false;
      }
    },

    // 수강 신청하기 시작
    moveReg() {
      this.$router.push("/user/reg/init");
    },

    // // 비밀번호 재설정 페이지로 이동
    // moveFixPW() {
    //     this.$router.push('/user/fixPW')
    // },

    // 신청내역 확인 페이지로 이동
    moveApplyList() {
      this.$router.push("/user/applyList");
    },
  },
};
</script>
